import { v4 as uuid } from 'uuid';
import { isPrivacyTextAvailable, isScheduleHeadingTextAvailable } from "./langUtil";
/*
 * be set when initAsOauth happened
 */
export default function setTranslations (translations) {
    this.translations = translations;
    this.hasPrivacyText = isPrivacyTextAvailable(translations);
    this.hasScheduleHeadingText = isScheduleHeadingTextAvailable(translations);
    this.injectDefaults();
    this.observed.translations = uuid();
}
